export { SwatchSelectorMinimal } from '../src/SwatchSelectorMinimal';
